import React from "react";
import { GetStaticPaths, GetStaticProps } from "next";
import { getLanguageStaticProps, languageStaticPaths } from "../../src/helper/languageHelper";
import KnowHowComponent from "../../src/pages/KnowHowComponent";

const KnowHow: React.FC<{}> = () => {
  return (<KnowHowComponent />);
};

export const getStaticProps: GetStaticProps = (context) => {
  return getLanguageStaticProps(context);
};

export const getStaticPaths: GetStaticPaths = async () => {
  return languageStaticPaths;
}

export default KnowHow;
